import { Component, OnInit } from '@angular/core';
import { Customers} from '../../../_models/customers';
import * as fromCustomers from '../../../customers/state/customers.reducer';
import * as customersActions from '../../../customers/state/customers.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './customers-shell.component.html'
})

export class CustomersShellComponent implements OnInit {

    // componentActive = true;
    // errorMessage$: Observable<string>;
    customerss$: Observable<Customers[]>;
    currentCustomers$: Observable<Customers>;
    filterFields$: Observable<any>;

  constructor(
    private store: Store<fromCustomers.State>
  ) {}

  ngOnInit() {

    // this.store.pipe(select(fromCustomers.getCustomersList),
    //   takeWhile(() => this.componentActive))
    //   .subscribe(
    //   customerss => {
    //         console.log(' >>>> Suscribirse a store getCustomersList: ');
    //         console.log(customerss);

    //         this.customerss = customerss;
    //       }
    // );

    this.customerss$ = this.store.pipe(select(fromCustomers.getCustomersList)) as Observable<Customers[]>;
    this.currentCustomers$ = this.store.pipe(select(fromCustomers.getCurrentCustomers)) as Observable<Customers>;
    this.filterFields$ = this.store.pipe(select(fromCustomers.getFilterFields)) as Observable<any>;
  }

  searchCustomerss(searchParams): void {

    console.log('---> GetCustomersList searchParam ');
    console.log(searchParams);

    this.store.dispatch( new customersActions.LoadCustomerss(searchParams));
    // Se guarda el valor de los filtros de búsqueda de las obras.
    this.store.dispatch( new customersActions.SetFilterFields(searchParams));

  } // End function searchCustomerss

  setCurrentCustomers(customersIn: Customers | null): void {

    console.log('---> setCurrentCustomers customersIn ');
    console.log(customersIn);

    // if (customersIn === null) {
    //   this.store.dispatch( new customersActions.InicializeCustomers());
    // }
    this.store.dispatch( new customersActions.SetCurrentCustomers(customersIn));
    // this.store.dispatch( new customersActions.LoadCurrencies());

  } // End function setCurrentCustomers

  deleteCustomers(deleteCustomers: Customers): void {

    console.log('---> deleteCustomers: ');
    console.log(this.deleteCustomers);

    this.store.dispatch( new customersActions.DeleteCustomers(deleteCustomers));

  } // End function deleteCustomers

} // End class CustomersShellComponent
